import React from 'react';
import {useTranslation} from '@deviceinsight/ng-ui-scale-lib/api';

export type Props = {
	/** translatable object, has properties `id` and `defaultValue` */
	trans: {
		id: string;
		defaultValue: string;
	};

	/** value for `<option>` */
	value: any;
};
/**
 * The Component was created because in 16.5.0 React the rendering of the `<option>` field was changed.
 * With this PR: https://github.com/facebook/react/pull/12078 - they allow only to put a String inside an `<option>` element.
 * They are going to give the possibility to pass something else like `<Trans />` in the future.
 * If this happens, we can remove this component again.
 * https://github.com/facebook/react/issues/14071
 * */

const TranslatedOption = ({trans: {id, defaultValue}, value, ...otherProps}: Props) => {
	const {t} = useTranslation();
	const translatedText = t(id, {
		defaultValue,
		...otherProps
	});
	return <option value={value}>{translatedText}</option>;
};

export default TranslatedOption;
